var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountShopSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28,8h-6V6.0830078c0-3.3085938-2.6914062-6-6-6s-6,2.6914062-6,6V8H4c-1.1025391,0-2,0.8974609-2,2v15 c0,3.859375,3.140625,7,7,7h14c3.859375,0,7-3.140625,7-7V10C30,8.8974609,29.1025391,8,28,8z M12,6.0830078 c0-2.2060547,1.7939453-4,4-4s4,1.7939453,4,4V8h-8V6.0830078z M28,25c0,2.7568359-2.2431641,5-5,5H9c-2.7568359,0-5-2.2431641-5-5 V10h6v4h2v-4h8v4h2v-4h6V25z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountShopSmall);
export default __webpack_public_path__ + "static/media/account-shop--small.a27906b5eaeaaff8be1b25247f16bc6b.svg";
export { ForwardRef as ReactComponent };